const baseEndpoint = '/email_verification/transactions';

export const paths = {
  create: baseEndpoint,
  validate: `${baseEndpoint}/:transactionKey/validate`,
};
